// @ts-strict-ignore
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Dialog, Input } from '@node-space/ui-components'
import { DocumentUpload } from 'types/verification'
import UploadCaseDocument from './UploadCaseDocument'

interface UploadDocumentModalProps {
  onClose: () => void
  onUpload: (document: DocumentUpload) => void
}

export const UploadDocumentModal = ({ onClose, onUpload }: UploadDocumentModalProps) => {
  const { t } = useTranslation()

  const [caseDocument, setCaseDocument] = useState<DocumentUpload>(null)
  const [documentDescription, setDocumentDescription] = useState('')
  const [hasChanged, setHasChanged] = useState(false)

  const documentTypeError = useMemo(
    () =>
      (documentDescription?.length && !documentDescription?.trim()?.length) ||
      (hasChanged && !documentDescription?.length),
    [documentDescription, hasChanged]
  )

  const uploadDocument = () => {
    caseDocument.description = documentDescription

    onUpload(caseDocument)
    onClose()
  }

  return (
    <Dialog
      title={t('documents.uploadADocument')}
      open
      onClose={onClose}
      type="utility"
      ActionButtons={[
        <Button
          key="uploadDocumentSubmit"
          type="submit"
          testId="uploadDocument"
          disabled={!documentDescription?.trim()?.length || !caseDocument}
          onClick={uploadDocument}
        >
          {t('documents.uploadDocument')}
        </Button>,
      ]}
    >
      <Box flexCol paddingB={24} gapY={16} testId="upload-document-form">
        <UploadCaseDocument file={caseDocument} setFile={setCaseDocument} />
        <Input
          value={documentDescription}
          onChange={e => {
            !hasChanged && setHasChanged(true)
            setDocumentDescription(e.target.value)
          }}
          label={t('formFields.documentDescription')}
          testId="documentDescription"
          placeholderText={t('formFields.shortDescription')}
          error={documentTypeError}
          errorText={t('fieldRequired', { field: t('formFields.documentDescription') })}
        />
      </Box>
    </Dialog>
  )
}
